import { useTranslation } from "react-i18next";
import { Sun, Moon, SunMoon } from "lucide-react";
import { NeuButton, NeuCard } from "../../components/neu/Neu";
import { usePrefs } from "../../context/PrefsContext";
import { WebPushToggle } from "./WebPushToggle";
import { NativePushRow } from "./NativePushRow";

const THEME_META = {
  light: { icon: Sun },
  dark: { icon: Moon },
  auto: { icon: SunMoon },
};

export const PreferencesCard = () => {
  const { t } = useTranslation();
  const { themeMode, setThemeMode } = usePrefs();
  return (
    <NeuCard className="p-6 sm:p-8" data-testid="preferences-card">
      <p className="label-xs text-sm">{t("settings.preferences")}</p>
      <div className="mt-4">
        <p className="mb-2 text-start text-sm text-muted-foreground">{t("app.theme")}</p>
        <div className="grid grid-cols-3 gap-2 sm:flex sm:flex-wrap">
          {["light", "dark", "auto"].map((m) => {
            const on = themeMode === m;
            const Icon = THEME_META[m].icon;
            return (
              <NeuButton
                key={m}
                data-testid={`theme-${m}`}
                variant={on ? "primary" : "default"}
                className={`flex items-center justify-center gap-2 px-5 py-3 text-base ${on ? "bg-emerald-600" : ""}`}
                onClick={() => setThemeMode(m)}
              >
                <Icon className={`h-4 w-4 ${on ? "" : "text-emerald-600"}`} /> {t(`app.${m}`)}
              </NeuButton>
            );
          })}
        </div>
        <p className="mt-2 text-start text-sm text-muted-foreground">{t("app.autoHint")}</p>
      </div>
      <div className="mt-5">
        <WebPushToggle />
        <NativePushRow />
      </div>
    </NeuCard>
  );
};
